import { render, staticRenderFns } from "./community-detail.vue?vue&type=template&id=063bdb78&scoped=true&"
import script from "./community-detail.vue?vue&type=script&lang=js&"
export * from "./community-detail.vue?vue&type=script&lang=js&"
import style0 from "./community-detail.vue?vue&type=style&index=0&id=063bdb78&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063bdb78",
  null
  
)

export default component.exports